/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";

const validationSchema = [
  Yup.object().shape({
    inspection_type: Yup.string(),

    'devicePrimary-actions-removed': Yup.boolean(), //disables all other actions, only unresolved if conditions are selected. Progress to second device installation here
    'devicePrimary-actions-installed': Yup.boolean(), // unresolved if conditions
    'devicePrimary-actions-cleaned': Yup.boolean(), // unresolved if conditions
    'devicePrimary-actions-battery_swap': Yup.boolean(), // unresolved if conditions other than power
    'devicePrimary-actions-hardware_changed': Yup.boolean(), // unresolved if conditions other than audio
    'devicePrimary-actions-cosmetically_fixed': Yup.boolean(), // unresolved if conditions other than vandalised, damaged
    'devicePrimary-actions-other': Yup.string(), // review status

    'deviceSecondary-uuid': Yup.string(),
    'deviceSecondary-serial_no': Yup.string(),
    'deviceSecondary-stop_id': Yup.string(),
    'deviceSecondary-info': Yup.object(),
  }),
  Yup.object().shape({
    title: Yup.string(),
    description: Yup.string(),
    maintenance_tag: Yup.string(),
    recordedAt: Yup.mixed(),
    recordType: Yup.boolean(),
    priority: Yup.string(),
    'devicePrimary-images': Yup.array(),//.min(1, "At least one image is required per inspection."),
    'deviceSecondary-images': Yup.array(),//.min(1, "At least one image is required per inspection."),
  }),
  Yup.object().shape({})
];

export default validationSchema;
